import { useEffect } from "react";
import styled from "styled-components/macro";
import SVG from "react-inlinesvg";
import { useSudowriteStore } from "../../stores/sudowriteStore";
import { themeVariables } from "../../themeVariables";
import { sendAppEvent } from "../../Utils";

const Container = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  background: var(--menu-color);
  border-radius: 24px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15), 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
  padding: 16px 16px 16px 19px;
  margin: 0 16px 16px 16px;
  width: auto;

  svg {
    path {
      fill: ${themeVariables.primaryCTA} !important;
    }
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  p {
    display: block;
    font-size: 15px;
    color: var(--grey-1);
    line-height: 130% !important;
    font-weight: 500;
  }
`;

const CtaButton = styled.button`
  margin-top: 0 !important;
  // margin-left: 20px;
  align-self: center;
  // margin-right: 20px;
  white-space: nowrap;
  padding: 7px 12px !important;
  border-radius: 10px !important;
  min-width: fit-content;
  background-color: ${themeVariables.primaryCTA} !important;
  border: 2px solid ${themeVariables.primaryCTA} !important; // so it matches the size of secondary CTA
  &:hover {
    background: ${themeVariables.primaryCATHover};
    color: ${themeVariables.ctaTextColor};
  }
`;

function CTAContent() {
  useEffect(() => {
    sendAppEvent("multiple_account_cta_viewed");
  }, []);

  const handleClick = () => {
    sendAppEvent("multiple_account_cta_clicked");
    window.location.href = "/app/plans?ref=multi";
  };

  return (
    <Container>
      <SVG
        height="40"
        width="40"
        src="/assets/heart.svg"
      />
      <MainContent>
        <p>
          We noticed you've signed up for multiple accounts. <strong>Sudowrite works best with a paid membership, and we offer a one week guarantee.</strong> Sign up to try all the features in full,
          and if you don't like it, just email us for a refund.
        </p>
      </MainContent>
      <CtaButton onClick={handleClick}>Start Risk-free Membership</CtaButton>
    </Container>
  );
}

function MultipleAccountCTAHost() {
  const subscription = useSudowriteStore((state) => state.subscription);

  if (!subscription.showMultipleAccountCTA) {
    return null;
  }

  return <CTAContent />;
}

export default MultipleAccountCTAHost;
